export const M = window.M;
export let External;

// Some dependencies might be loaded later, after the page loads.
// For example, grid.js or the builder widgets. Then this function will be called again and will ensure
// External is properly referring to global variables
export function resolveExternalDependencies() {
  External = {
    // components
    Website: window.Website,
    Tools: window.Tools,
    UITools: window.UITools,
    WebsiteSettings: window.WebsiteSettings,
    Multilingual: window.Multilingual,
    Popup: window.Popup,
    Templates: window.Templates,
    Grid: window.Grid,
    CPanel: window.CPanel,
    Button: window.Button,
    WebPlatform: window.WebPlatform,
    LinkPicker: window.LinkPicker,
    FileManager: window.FileManager,
    GlobalStyling: window.GlobalStyling,
    FormFields: window.FormFields,
    Widgets: window.Widgets,
    Permission: window.Permission,
    CSVContactsImporter: window.CSVContactsImporter,
    CSVProductsImporter: window.CSVProductsImporter,

    // helper functions
    jQuery: window.jQuery,
    $: window.$,
    getById: window.getById,
    indexOfId: window.indexOfId,
    getFileFromBase: window.getFileFromBase,
    getThumbnailsFromBase: window.getThumbnailsFromBase,
    getIconForProperty: window.getIconForProperty,
    mergeUnique: window.mergeUnique,
    format: window.format,
    escapeFormat: window.escapeFormat,
    escapeHtml: window.escapeHtml,
    isUndefined: window.isUndefined,
    staticResource: window.staticResource,
    Log: window.Log,
    ButtonStyleHelper: window.ButtonStyleHelper,
    BookingCommon: window.BookingCommon,

    // constants
    CRM_FILTER_TYPE: window.CRM_FILTER_TYPE,
    CRM_PROPERTY_TYPE: window.CRM_PROPERTY_TYPE,
    CRM_FILTER_FUNCTION_NAMES: window.CRM_FILTER_FUNCTION_NAMES,
    STORE_PRODUCT_TYPE: window.STORE_PRODUCT_TYPE,
    COUNTRY_CODES: window.COUNTRY_CODES,
    COUNTRIES: window.COUNTRIES,
    STATES_ISO: window.STATES_ISO,
    WIDGET_TYPE: window.WIDGET_TYPE,
    CRM_MESSAGE_TYPE: window.CRM_MESSAGE_TYPE,
    CRM_MESSAGE_CHANNEL: window.CRM_MESSAGE_CHANNEL,
    CRM_MESSAGE_OPTIONS: window.CRM_MESSAGE_OPTIONS,
    WHATSAPP_TEMPLATE_STATUS: window.WHATSAPP_TEMPLATE_STATUS,

    // global variables
    content: window.content,
    resources: window.resources,
    resourcesVersion: window.resourcesVersion,
    subdomain: window.subdomain,
    domain: window.domain,
    primaryDomain: window.primaryDomain,
    userDomain: window.userDomain,
    projectId: window.projectId,
    userId: window.userId,
    userName: window.userName,
    userEmail: window.userEmail,
    userLocale: window.userLocale,
    platformCountry: window.platformCountry,
    createdTime: window.createdTime,
    contextPath: window.contextPath,
    emailReviewAccountsLink: window.emailReviewAccountsLink,
    showBuilderPopupsOnFullHeight: window.showBuilderPopupsOnFullHeight,
    platformId: window.platformId,
    serviceApiDomain: window.serviceApiDomain,
    getUserDir: window.getUserDir,
    PhoneInput: window.PhoneInput,
    siteId: window.websiteId,
    resellerId: window.platformId,
    wl: window.platformId !== 1
  }
}

resolveExternalDependencies();
